/*
  PDP Custom CTA — Buy Now (Pause Rituals)
  "Add to Cart" (ghost) is Dawn's normal submit (AJAX add + cart drawer).
  "Buy Now" (green) goes DIRECT to checkout with ONLY the current product, using a Shopify
  cart permalink (/cart/{variant_id}:{qty}). The permalink builds a checkout from just that
  variant — it does NOT include items already in the cart. (Fixes the old AJAX-add-then-
  /checkout flow, which merged the existing cart into the order.)
  Idempotent; re-inits on Shopify section load (theme editor).
*/
(function () {
  function permalinkBase() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '');
  }

  function setLoading(btn, on) {
    var spinner = btn.querySelector('.loading__spinner');
    btn.classList.toggle('loading', on);
    if (on) {
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('aria-disabled');
    }
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  // read the CURRENTLY selected variant id (Dawn keeps [name="id"] in sync on variant change)
  function currentVariantId(form) {
    var input = form && form.querySelector('[name="id"]');
    return input && input.value ? input.value : null;
  }

  function onBuyNow(e) {
    var btn = e.currentTarget;
    if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;

    var form = btn.closest('form');
    var variantId = currentVariantId(form);
    if (!variantId) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = (qtyInput && parseInt(qtyInput.value, 10)) || 1;

    e.preventDefault();
    setLoading(btn, true);
    // cart permalink → straight to checkout with ONLY this item (ignores existing cart)
    window.location.href = permalinkBase() + '/cart/' + variantId + ':' + qty;
  }

  function init(root) {
    (root || document).querySelectorAll('[data-pdp-buy-now]').forEach(function (btn) {
      if (btn.dataset.buyReady === 'true') return;
      btn.dataset.buyReady = 'true';
      btn.addEventListener('click', onBuyNow);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
